import React, { useState } from "react";
import { ENDPOINTS } from "../config/api";
import { useNavigate } from "react-router-dom";

const ForgotPassword = () => {
  const [documento, setDocumento] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");

    try {
      const res = await fetch(ENDPOINTS.ForgotPassword, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ documento }),
      });

      const data = await res.json();

      if (!data.success) {
        setError(data.message);
        return;
      }

      setMessage(data.message);

    } catch (err) {
      console.log(err);
      setError("Error en el servidor");
    }
  };

  return (
    <div className="container mt-5 mb-5 pt-5" style={{ maxWidth: "500px" }}>
      <div className="card p-4 shadow-sm pt-5 pb-5">

        <h4 className="text-center mb-2">Recuperar contraseña</h4>
        <h6 className="text-center text-secondary mb-3">Olvidar tu contraseña ya no será un problema</h6>

        {error && <div className="alert alert-danger">{error}</div>}
        {message && <div className="alert alert-success">{message}</div>}

        <form onSubmit={handleSubmit}>

          <input
            type="text"
            className="form-control mb-3"
            value={documento}
            onChange={(e) => setDocumento(e.target.value)}
            placeholder="Ingresa tu documento"
          />

          <button className="btn btn-outline-pink w-100">
            Recuperar contraseña
          </button>
        </form>

         <div className="mt-3 d-flex justify-content-center align-items-center">
            <button type="button" className="btn btn-outline-purple w-50" onClick={() => navigate("/login")}>
            Volver al inicio de sesión
            </button>
        </div>

      </div>
    </div>
  );
};

export default ForgotPassword;
